<template>
  <div class="sarai-action-page">

    <div>
      <sarai-form
        :gurudwara-id="computedGurudwaraId"
        :sarai-id="computedSaraiId"
        :is-edit-mode="computedIsEditMode"
        @saved="handleSaved"
        @cancelled="handleBackClick"
      />
    </div>
  </div>
</template>

<script>
import SaraiForm from './SaraiForm.vue'

export default {
  name: 'SaraiActionPage',
  components: {
    SaraiForm
  },
  props: {
    gurudwaraId: {
      type: String,
      default: null
    },
    saraiId: {
      type: String,
      default: null
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // Fallback to route params if props are not provided (for backward compatibility)
    computedGurudwaraId() {
      return this.gurudwaraId || this.$route.params.gurudwaraId
    },
    computedSaraiId() {
      return this.saraiId || this.$route.params.saraiId
    },
    computedIsEditMode() {
      return this.isEditMode || !!this.computedSaraiId
    }
  },
  methods: {
    handleBackClick() {
      // If used as modal (props provided), emit close event
      if (this.gurudwaraId !== null) {
        this.$emit('close')
      } else {
        // Otherwise use router navigation (backward compatibility)
        if (this.computedGurudwaraId) {
          this.$router.push({
            path: `/gurudwara/${this.computedGurudwaraId}/edit`,
            query: { tab: 'sarai' }
          })
        } else {
          this.$router.push('/gurudwara/list')
        }
      }
    },
    handleSaved() {
      this.handleBackClick()
    }
  }
}
</script>

<style scoped>

.sarai-action-page {
  background: var(--page-bg);
  padding: 16px 24px 0;
  height: 100%;
  box-sizing: border-box;
  color: var(--text-primary);
}

.sarai-action-page > div {
  height: 100%;
}
</style>

